import React from "react";
import { Animate } from "react-move";

import { easeBounceOut } from "@/utils/animation";
import base64 from "@/utils/base64";

import { Point } from "../MeterConstants";

export type MeterVoteHandleProps = {
  icons: IIcons;
  voteUserIconPoint?: Point;
  dropVoteUserIcon: boolean;
};

const MeterUserIconHandle: React.FC<MeterVoteHandleProps> = ({
  icons,
  voteUserIconPoint,
  dropVoteUserIcon,
}) => {
  if (!voteUserIconPoint) return null;

  const animationConfig = dropVoteUserIcon
    ? { y: [voteUserIconPoint.y], timing: { duration: 1 } }
    : {
        y: [voteUserIconPoint.y],
        timing: { duration: 700, ease: easeBounceOut },
      };

  return (
    <g>
      <Animate start={{ y: voteUserIconPoint.y }} update={animationConfig}>
        {(animation: { y: number }) => (
          <g transform={`translate(${voteUserIconPoint.x}, ${animation.y})`}>
            <image
              xlinkHref={`data:image/svg+xml;base64,${base64.encode(
                icons.Picker
              )}`}
              x={-32}
              y={-32}
              width={64}
              height={64}
              onDragStart={(e) => e.preventDefault()}
            />
          </g>
        )}
      </Animate>
    </g>
  );
};

export default MeterUserIconHandle;
